/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface DebugFlowMutationProps {
    debug: boolean;
    flow_id: string;
    organisation_id: string;
}

export default class DebugFlowMutation extends Relay.Mutation<DebugFlowMutationProps> {
    static propTypes = {
        debug: PropTypes.bool.isRequired,
        flow_id: PropTypes.string.isRequired,
        organisation_id: PropTypes.string.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {debugFlow}`;
    }

    getVariables() {
        return {
            flow_id: this.props.flow_id,
            organisation_id: this.props.organisation_id,
            debug: this.props.debug,
        };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on DebugFlowPayload {
              clientMutationId,
              updatedNode {
                  id,
                  realId,
                  debug,
                  debugUntil
              }
          }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
